import { ref } from 'vue';

const visibilityHidden = ref(false);

document.onvisibilitychange = () => {
  visibilityHidden.value = document.hidden;
};

export default function useVisibility() {
  return {
    visibilityHidden,
  };
}
